<template>
  <div id="app"
       v-bind:class="{blueBg: $route.meta.isBlueBg, transHeader : hasTransHeader, isAuthView: $route.meta.isAuthView, isLoggedOut : !$route.meta.isAuthView && !$store.state.user.scope}">

    <boot-loader :loadingMessage="loadingMessage"></boot-loader>
    <mu-drawer v-if="loggedIn" v-show="!$route.meta.isAuthView" class="app-drawer" :open="isOpen" :docked="docked"
               @close="toggle(false)" v-bind:class="{isMobile: !docked}">
      <mu-content-block class="nav-head">
        <mu-avatar
          v-if="$store.state.user.scope.profile_thumb !== null"
          :size="28"
          :src="$store.state.user.scope.profile_thumb"
          color="white"
          backgroundColor="grey"
          @click="goToProfile"
        >
        </mu-avatar>
        <mu-avatar
          v-else
          class="blue"
          :size="28"
          color="white"
          backgroundColor="grey"
          @click="goToProfile"
        >
          {{upperTwoInitials}}
        </mu-avatar>
        <div class="name" v-text="$store.state.user.scope.display_name && $store.state.user.scope.use_display_name ? $store.state.user.scope.display_name:  $store.state.user.scope.firstname"></div>
        <mu-icon-menu icon="settings" :open="menuOpen" desktop v-if="$store.state.user.scope"
                      menuListClass="hasAvatar dashboard-menu">

          <user-avatar @click="goToProfile()"
                       style="width: 100%; margin-top: -16px; margin-bottom: -8px;"></user-avatar>
          <mu-divider/>
          <mu-menu-item
            :title="$t('message.dashboardAppBarText')" leftIcon="dashboard"
            @click="goTo('/dashboard')"/>
          <mu-menu-item v-if="!isHcpView"
                        :title="$t('message.discussionTabMyQuestions')" leftIcon="chat"
                        @click="goTo('/questions?type=MY_QUESTIONS')"/>
          <mu-menu-item
            :title="$t('message.labelMyProfile')" leftIcon="person"
            @click="goTo('/profile/' + $store.state.user.profile.profile_url)"/>
          <mu-menu-item :title="$t('message.settingsMenuTitleText')" @click="goTo('/settings')"
                        leftIcon="settings_cog"/>
          <mu-divider v-if="!isHcpView"/>
          <mu-menu-item v-if="!isHcpView" v-tooltip.left="$t('message.labelAddHealthSnapshot')" leftIcon="add"
                        :title="$t('message.addProgressAppBarText')"
                        @click.native="goTo('/add-progress')"></mu-menu-item>
          <mu-menu-item v-if="!isHcpView" v-tooltip.left="$t('message.labelAddFoods')" leftIcon="add"
                        :title="$t('message.foodDiaryAddFoodAppBarText')"
                        @click.native="goTo('/food-diary/')"></mu-menu-item>
          <mu-divider v-if="!isHcpView"></mu-divider>
          <mu-menu-item v-if="!isHcpView" :title="$t('message.addTestimonialText')" :disabled="showTestimonial"
                        leftIcon="edit"
                        @click="goTo('/testimonials')"></mu-menu-item>
          <mu-menu-item v-if="!isHcpView" :title="$t('message.labelHelp')" leftIcon="live_help"
                        @click.native="goToContact"/>
          <mu-menu-item :title="$t('message.logOutText')" leftIcon="exit_to_app" @click.native="logOut"/>
        </mu-icon-menu>
      </mu-content-block>
      <mu-list id="nav" style="margin-top: 0px !important;" @itemClick="docked ? '' : toggle(false)">
        <mu-list-item to="/dashboard" :title="$t('message.dashboardMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" :value="isHcpView && isHcpUser ? 'home' : 'dashboard'"></mu-icon>
        </mu-list-item>
        <mu-list-item v-if="isHcpView" to="/hcp" :title="'Education'" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="school"></mu-icon>
        </mu-list-item>
        <mu-list-item :to="isHcpView && isHcpUser ? '/life/category/evidence-and-papers' : '/life'"
                      :title="isHcpView && isHcpUser ? 'Evidence and Papers' : $t('message.lifestyleMenuTitleText')"
                      @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="local_florist"></mu-icon>
        </mu-list-item>
        <mu-list-item to="/downloads" v-if="isHcpUser && isHcpView" title="Resources" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="file_downloads"></mu-icon>
        </mu-list-item>
        <mu-list-item :to="!isHcpVerified && isHcpView ? '' : '/questions'" :disabled="!isHcpVerified && isHcpView"
                      :title="isHcpView && isHcpUser ? 'Forum' : $t('message.questionsMenuTitleText')"
                      @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" :value="isHcpView || isHcpUser ? 'textsms' : 'live_help'"></mu-icon>
        </mu-list-item>
        <mu-list-item v-if="!isHcpView" to="/food-diary" :title="$t('message.foodDiaryMenuTitleText')"
                      @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="book"></mu-icon>
        </mu-list-item>

        <mu-list-item class="recipe-menu" :title="$t('message.recipeMenuTitleText')" toggleNested :open="false">
          <mu-icon class="left8" slot="left" value="restaurant"/>
          <mu-list-item slot="nested" title="All Recipes" to="/recipes/" :exact="true" @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="view_carousel"/>
          </mu-list-item>


          <mu-list-item disableRipple slot="nested" title="Favourites" to="/recipes/favorites/"
                        @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="grade"/>
          </mu-list-item>

          <mu-list-item disableRipple slot="nested" title="Search" to="/recipes/search" @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="search"/>
          </mu-list-item>

          <mu-list-item disableRipple slot="nested" title="Meal Plan Generator" to="/recipes/generator/"
                        @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="refresh"/>
          </mu-list-item>


          <mu-list-item disableRipple slot="nested" title="My Meal Plans" to="/recipes/mealplans/"
                        @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="view_list"/>
          </mu-list-item>


        </mu-list-item>

        <mu-list-item class="shop-menu" v-if="!isHcpView" :title="$t('message.shopMenuTitleText')"
                      @click.native="closeIfMobile" toggleNested :open="false">
          <mu-icon class="left8" slot="left" value="shopping_cart"></mu-icon>

          <mu-list-item disableRipple slot="nested" title="Books" target="_blank" href="https://shop.lowcarbprogram.com/collections/books"
                        @click.native="closeIfMobile">
            <mu-icon class="left8" slot="left" value="book"/>
          </mu-list-item>

        </mu-list-item>



        <mu-list-item v-if="!isHcpView" to="/add-progress" :title="$t('message.addProgressMenuTitleText')"
                      @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="add_plus"></mu-icon>
        </mu-list-item>
        <mu-list-item v-if="!isHcpView && $store.state.user.scope.country.country_id === 41" to="/coaching"
                      :title="$t('message.coachingMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="school"></mu-icon>
        </mu-list-item>
        <mu-list-item to="/downloads" v-if="!isHcpUser || !isHcpView" :title="$t('message.downloadsMenuTitleText')"
                      @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="file_downloads"></mu-icon>
        </mu-list-item>
        <mu-list-item to="/coaching" title="Coaching" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="sports"></mu-icon>
        </mu-list-item>

        <mu-list-item v-if="!isHcpView" :to="'/profile/' + $store.state.user.profile.profile_url"
                      :title="$t('message.profileMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="person"></mu-icon>
        </mu-list-item>
        <mu-list-item to="/contact" :title="$t('message.feedbackMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="feedback"></mu-icon>
        </mu-list-item>
        <mu-list-item to="/settings" :title="$t('message.settingsMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="settings"></mu-icon>
        </mu-list-item>
        <mu-list-item v-if="!isHcpView" to="/faq" :title="$t('message.faqMenuTitleText')" @click.native="closeIfMobile">
          <mu-icon class="left8" slot="left" value="help"></mu-icon>
        </mu-list-item>
        <mu-list-item class="hcpSwitch" v-if="isHcpView || isHcpUser" :disabled="!isHcpVerified && isHcpView"
                      :title="isHcpView ? $t('message.labelSwitchPatient') : $t('message.labelSwitchHcp')"
                      @click="toggleHcpSwitchModal = true">
          <mu-icon class="left8" slot="left" value="swap_horizontal_circle"></mu-icon>
        </mu-list-item>
      </mu-list>
      <payment-call-to-action v-if="$store.state.status.payment.paid === false"></payment-call-to-action>
<!--      <provider></provider>-->
    </mu-drawer>
    <div v-if="!loading" class="page-content" v-bind:class="{sidebarOpen: isOpen, isMobile: !docked}">

      <!-- LoggedOut Auth View App Bar -->
      <mu-appbar
        v-if="($route.meta.isAuthView && !$route.meta.hideRegisterAppBar)"
        v-bind:class="{appBarClosed: !isOpen, noShadow: $route.meta.hideShadow}"
        align="center">
        <mu-flexbox align="center" justify="center">
          <mu-flexbox-item align="center">
            <img v-if="applicationContext === 'grohealth'" width="26" class="logo" src="~assets/gro-small.png">
            <img v-if="applicationContext === 'lowcarbprogram'" width="200" class="logo"
                 src="static/logos/lcp-logo.svg">
          </mu-flexbox-item>
          <div v-if="showLogOut" class="logout-button" @click="logOut">
            <span>
              <mu-icon value="exit_to_app" />
              Log out
            </span>
          </div>
        </mu-flexbox>
      </mu-appbar>
      <!-- LoggedIn App Bar -->
      <mu-appbar
        v-if="!$route.meta.isAuthView && $store.state.user.scope"
        :title="replaceTitle ? replaceTitle : $route.meta.title  + ($route.meta.hasCustomTitle ? ': ' + externalTitle : '')"
        v-bind:class="{appBarClosed: !isOpen, transparent: $route.meta.isBlueBg}">
        <mu-icon-button
          iconClass="menu-icon material-icons-round"
          icon="menu"
          slot="left"
          @click="toggle(false)"
        />
        <mu-icon-button
          class="animated fadeInRight"
          v-if="$route.meta.isChild"
          icon="chevron_left"
          slot="left"
          @click="goBack($route)"
        />
        <mu-icon
          v-if="(isHcpView || isHcpUser) && isHcpVerified"
          value="swap_horizontal_circle"
          color="#FFF"
          class="mobileHcpSwitch"
          @click="toggleHcpSwitchModal = true"
          slot="right"
        />

        <div slot="right" style="margin-right: 20px;display: flex;align-items:center; ">
          <span class="user-block pointer" @click="goToProfile()" slot="right">{{$store.state.user.scope.use_display_name ? $store.state.user.scope.display_name : $store.state.user.scope.firstname}}</span>

          <mu-avatar
            v-if="$store.state.user.scope.profile_thumb !== null"
            style="margin-left: 12px;border: 2px solid #fff;"
            :size="32"
            :src="$store.state.user.scope.profile_thumb"
            color="white"
            backgroundColor="grey"
            @click="goToProfile"
          >
          </mu-avatar>
          <mu-avatar
            v-else
            class="blue"
            style="margin-left: 12px;border: 2px solid #fff;"
            :size="32"
            color="white"
            backgroundColor="grey"
            @click="goToProfile"
          >
            {{upperTwoInitials}}
          </mu-avatar>

        </div>
        <notifications-panel
          v-if="$store.state.user.scope"
          :visible="isNotificationsPanelVisible"
          @panelHidden="hidePanelFn"
          v-on-clickaway="away"
          slot="right"
          style="margin-right: 20px;"
        ></notifications-panel>
      </mu-appbar>

      <!-- LoggedIn App Bar -->
      <mu-appbar
        v-if="!$route.meta.isAuthView && !$store.state.user.scope"
        :title="$route.meta.title  + ($route.meta.hasCustomTitle ? ': ' + externalTitle : '')"
        v-bind:class="{appBarClosed: !isOpen}">
      </mu-appbar>

      <mu-content-block class="main-content" v-bind:id="$route.meta.id" @scroll.native="handleScroll">
        <hcp-search v-if="isHcpView && isHcpUser"></hcp-search>

        <router-view v-if="$store.state.list.diabetes_types"></router-view>


        <footer class="siteFooter content" style="clear:both">

          <mu-row>
            <mu-col width="25" tablet="25" desktop="25">

            </mu-col>
            <mu-col width="50" tablet="50" desktop="50" align="center">


              <!-- <language-picker></language-picker> -->
              <div>

                {{$t('message.labelMadeWith')}}

                <mu-icon color="#D83E38" :size="12" value="favorite"></mu-icon>
                <span v-if="applicationContext === 'grohealth'">grohealth.com</span>
                <span v-if="applicationContext === 'lowcarbprogram'">lowcarbprogram.com</span> &copy; {{currentYear}}
              </div>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">

            </mu-col>
          </mu-row>
        </footer>

      </mu-content-block>
      <paywall v-if="$route.meta.paymentWall && $store.state.status.payment.paid === false" :show="showPaywall"/>
      <hcp-switch-modal v-if="isHcpUser" :open="toggleHcpSwitchModal" @close="closeHcpSwitchModal()"/>
    </div>
  </div>
</template>
<script>

  import config from './config'

  import {directive as onClickaway} from 'vue-clickaway';
  import UserApi from './api/User';
  import ListApi from './api/Lists'
  import GeoApi from "./api/Geo"


  import EventBus from './helpers/EventBus'
  import UserAvatar from "./components/UserAvatar/UserAvatar";
  import UserManager from './helpers/UserManager';
  import ProviderApi from './api/Provider'
  import IOManager from './helpers/IOManager'
  import NotificationsPanel from "./components/Notifications/Notifications";
  import AuthenticationManager from './helpers/AuthenticationManager'
  import Provider from './components/Provider/Provider.vue'
  import BootLoader from "./components/BootLoader/BootLoader";
  import Pusher from './helpers/PusherManager';
  import MuMenuItem from "muse-ui/src/menu/menuItem";
  import MuMenu from "muse-ui/src/menu/menu";
  import MuDivider from "muse-ui/src/divider/divider";
  import axios from 'axios'

  axios.defaults.headers.common['applicationContext'] = config.ApplicationContext;

  import HCPMixin from './mixins/HCPMixin';
  import Paywall from "./views/Payment/Paywall/Paywall";
  import LanguagePicker from "./components/LanguagePicker/LanguagePicker";
  import Config from '../config'
  import PaymentCallToAction from "./components/PaymentCTA/PaymentCallToAction";


  //import raygun4js from 'raygun4js'
  import MuTextField from "../node_modules/muse-ui/src/textField/textField";
  import MuContentBlock from "../node_modules/muse-ui/src/contentBlock/contentBlock";
  import HcpSearch from "./components/HCP/Search";
  import HcpSwitchModal from "./components/HCP/SwitchProgram";
  import _ from "lodash";
  import ListsApi from "./api/Lists";

  // raygun4js('enableCrashReporting', true);
  //raygun4js('apiKey', config.RaygunKey);
  // raygun4js('enablePulse', true);


  export default {
    mixins: [
      HCPMixin
    ],
    watch: {
      'connected': function () {
        let self = this;
      },
      '$route': function (from, to) {
        let self = this;
        if (self.$route.name === 'Dashboard') {
          self.getUser();
          self.showPaywall = false;

          if($(window).width() >= 1196) {
            self.docked = true;
            self.isOpen = true;
          }
        } else {
          self.showPaywall = true;
        }

        if (to.name !== 'Subscription') {
          self.checkOnboarding();
        }

        self.initPusher();

        self.replaceTitle = '';

        self.hasTransHeader = self.$route.meta.hasTransHeader;
        self.initializeLifeStyleTransparentHeader();
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        }
        if ($(window).width() <= 1196) {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          }
        } else {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          }
        }
      }
    },
    components: {
      HcpSwitchModal,
      HcpSearch,
      MuContentBlock,
      MuTextField,
      LanguagePicker,
      Paywall,
      MuDivider,
      MuMenu,
      MuMenuItem,
      BootLoader,
      Provider,
      NotificationsPanel,
      UserAvatar,
      PaymentCallToAction
    },
    name: 'app',
    directives: {
      onClickaway: onClickaway,
    },
    data() {
      return {
        toggleHcpSwitchModal: false,
        externalTitle: '',
        replaceTitle: '',
        applicationContext: config.ApplicationContext,
        isLowCarb: Config.ApplicationContext === 'lowcarbprogram',
        hasTransHeader: false,
        isNotificationsPanelVisible: false,
        menuOpen: false,
        connected: true,
        isOpen: false,
        docked: false,
        loading: false,
        loadingMessage: "",
        loader: false,
        pusher: null,
        showTestimonial: false,
        showPaywall: true,
        currentYear: moment().format('YYYY'),
        supportedLocales: [
          {
            name: 'en_gb',
            time: 'en'
          },
          {
            name: 'fr_ca',
            time: 'fr'
          }
        ]
      }
    },
    mounted() {
      let self = this;

      self.checkOnboarding();


      axios.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions")
        .then(function (response) {
          self.$store.commit('setRecipeCategories', {
            suitabilities: response.data.suitabilities,
            dietaryTypes: response.data.dietaryTypes,
            cuisines: response.data.cuisines,
            occasions: response.data.occasions,
            categories: response.data.categories,
          })
        });


      if (self.$route.name === 'Dashboard') {
        self.showPaywall = false;
      }

      EventBus.$on('App::triggerPaywall', (data) => {
        self.showPaywall = data;
        self.$forceUpdate();
      });

      self.initializeLifeStyleTransparentHeader();

      self.loadingMessage = self.$t('message.bootloaderConnecting');

      Promise.all([
        GeoApi.geoIp(),
        ListApi.getGettingStartedList(),
        ListApi.getMoodsList(),
        ListsApi.getExternalLoginList()])
        .then((responses) => {
          self.$store.commit('setGeoLocation', responses[0].data);

          self.loadingMessage = self.$t('message.bootloaderDownloadingAssets');
          self.$store.commit('setList', responses[1].data);

          self.loadingMessage = self.$t('message.bootloaderInitializing');
          self.$store.commit('setMoodList', responses[2].data);
          self.$store.commit('setLoginProviders', responses[3].data.providers)
        });


      if (AuthenticationManager.hasToken()) {
        const tokenObject = AuthenticationManager.getToken();
        if (tokenObject.expires < new Date()) {
          AuthenticationManager.refreshAccessToken(tokenObject).then(() => {
            self.loadingMessage = self.$t('message.bootloaderProfile');
            self.getUser();
          });
        } else {
          AuthenticationManager.setToken(tokenObject);
          self.loadingMessage = self.$t('message.bootloaderProfile');
          self.getUser();
        }

      }

      let StatusChecker = new IOManager();
      setInterval(function () {
        StatusChecker.ConnectivityStatusWithAppState(self);
      }.bind(self), 5000);

      EventBus.$on('App::triggerLoading', function () {
        self.loader = true;
      });

      EventBus.$on('App::stopLoading', function () {
        self.loader = false;
      });

      //Add's semi colon to app bar to add custom title after a semi colon
      EventBus.$on('App::setCustomTitle', function (title) {
        self.externalTitle = title;
      });

      EventBus.$on('App::setReplaceTitle', function (title) {
        self.replaceTitle = title;
      });

      EventBus.$on('App::dockerResizerStart', function () {
        self.barDockerListen();
      });

      self.$EventBus.$on('App::_onIdle', function () {
        if (self.loggedIn) {
          //the below values must be the keys for the localisation value
          self.$store.commit('setFlashMessage', {
            type: 'error',
            title: self.$t('message.idleLogoutTitle'),
            body: self.$t('message.idleLogoutBody')
          });

          self.logOut();
        }
      });

      if ($(window).width() <= 1196) {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = false;
        }
      } else {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = true;
        }
      }
      if (self.$route.meta.hideLeftNav === true) {
        self.docked = false;
        self.isOpen = false;
      }
      self.barDockerListen();

      document.addEventListener("touchstart", function () {
      }, true);

      // switch program
      EventBus.$on('App::onProgramSwitch', () => {
        self.$store.state.user.scope = "";
        self.loadingMessage = "Switching Program ...";
        setTimeout(function () {
          self.getUser();
        }, 2000);
      });
    },
    methods: {
      closeHcpSwitchModal(e) {
        let self = this;
        self.toggleHcpSwitchModal = false;
      },
      getUser() {
        let self = this;
        UserApi.getUser().then(function (response) {
          let user = response.data;
          self.$store.commit('setUser', user);

          let weeks = 2, weekDays = weeks * 7, now = moment();
          if (_.has(self.$store.state.user.scope, 'date_joined')) {
            if (now <= moment(self.$store.state.user.scope.date_joined).add('days', weekDays)) {
              self.showTestimonial = true;
            }
            self.showTestimonial = false;
          }


          axios.get(config.apiUrl + 'user/updateComm/' + response.data.scope.user_id)
            .then(function (response) {
            });


          UserApi.onBoardingStatus()
            .then(function (response) {
              self.$store.commit('setOnBoardingStatus', response.data);
              self.checkOnboarding();
            });

          ProviderApi.getProvider().then(function (response) {
            self.$store.commit('setProvider', response.data);
            self.loading = false;
          });

          // pusher
          self.initPusher();

          const tokenObject = AuthenticationManager.getToken();
          if(!_.has(tokenObject, 'refreshToken')) {
            return;
          }

          AuthenticationManager.refreshAccessToken(tokenObject).then(() => {
            if (_.includes(AuthenticationManager.parseJwt().scope, 'standard_tasks')) {
              self.$store.commit('setPaymentStatus', true);
            } else if (_.includes(AuthenticationManager.parseJwt().scope, 'unsubscribed_tasks')) {
              self.$router.push({
                path: '/subscribe'
              });
            }
          });
        })
      },
      initPusher() {
        let self = this;

        if (self.loggedIn) {
          let userId = self.$store.state.user.scope.user_id;

          Pusher.unsubscribe('settings_' + userId);
          Pusher.unsubscribe('payment_' + userId);
          Pusher.unsubscribe('profileUpdated_' + userId);
          Pusher.unsubscribe('queueSyncComplete_' + userId);
          Pusher.unsubscribe('subscription_' + userId);

          self.pusher = Pusher.subscribe('payment_' + userId);
          self.pusher.bind('refund', (data) => {
            if (data.refunded === true) {
              self.$store.state.status.payment.paid = false;
              self.showPaywall = true;
              self.$forceUpdate();
            }
          });

          let subscr = Pusher.subscribe('payment_' + userId);
          subscr.bind('cancel', (data) => {
            if (data.cancelled === true) {
              self.$store.state.status.payment.paid = false;
              self.showPaywall = true;
              self.$forceUpdate();
            }
          });

          let bindProfilePicture = Pusher.subscribe('profileUpdated_' + userId);
          bindProfilePicture.bind('profileUpdated', function (data) {
            self.$store.state.user.scope.firstname = data.firstname;
            self.$store.state.user.scope.surname = data.surname;
            self.$store.state.user.scope.display_name = data.display_name;
            self.$store.state.user.scope.use_display_name = data.use_display_name;
            self.$store.state.user.scope.profile_thumb = data.profile_thumb;
            self.$store.state.user.scope.profile_large = data.profile_large;
          });

          let bindSettings = Pusher.subscribe('settings_' + userId)
          bindSettings.bind('onSettingsChange', function (data) {
            if (_.has(data, 'onAccountChange')) {
              let account = data.onAccountChange;
              self.$store.state.user.scope.firstname = account.firstname;
              self.$store.state.user.scope.surname = account.surname;
              self.$store.state.user.scope.display_name = account.surname;
              self.$store.state.user.scope.use_display_name = account.use_display_name;
              self.$store.commit('setAccount', account);
            }

            if (_.has(data, 'onUnitsWebChange')) {
              self.$store.state.user.settings = data.onUnitsWebChange;
            }
          });

          let bindPulseSyncComplete = Pusher.subscribe('queueSyncComplete_' + userId);
          bindPulseSyncComplete.bind('heartRate', (data) => {
            if (data.service === 'STRIIV') {
              self.$toastr.success(`New pulse readings imported from Striiv`);
            }
          });

        }
      },
      barDockerListen() {
        let self = this;
        $(window).resize(function () {
          if ($(window).width() <= 1196) {
            if (self.$route.meta.hideLeftNav === true) {
              self.docked = false;
              self.isOpen = false;
            } else {
              self.docked = true;
              self.isOpen = false;
            }
          } else {
            if (self.$route.meta.hideLeftNav === true) {
              self.docked = false;
              self.isOpen = false;
            } else {
              self.docked = true;
              self.isOpen = true;
            }
          }
        });
      },
      handleScroll: function (e) {
        let self = this;
        self.initializeLifeStyleTransparentHeader();
      },
      initializeLifeStyleTransparentHeader() {
        let self = this;
        self.hasTransHeader = self.$route.meta.hasTransHeader;
        let el = '#' + self.$route.meta.id;
        if (self.hasTransHeader === true) {
          // if has trans and is life
          if (self.$route.name === "LifeStyleArticle") {
            if ($(el).scrollTop() >= $(el).outerHeight() - 64) {
              if (self.hasTransHeader === true)
                self.hasTransHeader = false;
            } else {
              if (self.hasTransHeader === false) {
                self.hasTransHeader = true;
              }
            }
          }
        }
      },
      goTo(path) {
        let self = this;
        self.$router.push({
          path: path
        })
      },
      closeAppMenu() {
        let self = this;
        self.menuOpen = false;
        self.$forceUpdate();
      },
      closeIfMobile() {
        let self = this;
        if ($(window).width() <= 1196) {
          self.docked = true;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = true;
        }
      },
      goToProfile() {
        let self = this;
        if (self.isHcpUser && self.isHcpView) {
          self.$router.push({
            path: `/profile/`
              + self.$store.state.user.profile.profile_url
          });
        } else {
          self.$router.push({
            path: `/profile/` + self.$store.state.user.profile.profile_url + '/progress'
          });
        }
      },
      toggle(flag) {
        this.isOpen = !this.isOpen;
        EventBus.$emit('redraw');
        if ($(window).width() <= 1196) {
          this.docked = false;
        } else {
          this.docked = true;
        }
      },
      logOut() {
        let self = this;

        self.$store.commit('setOnBoardingStatus', {});
        self.$store.commit('setPaymentStatus', {});
        self.$store.commit('setLessons', []);
        self.$store.commit('setUser', {});
        self.$store.commit('setAccount', {});
        self.$store.commit('setBloodGlucoseCard', {});
        self.$store.commit('setBloodPressureCard', {});
        self.$store.commit('setNutritionCard', {});
        self.$store.commit('setWeightCard', {});
        self.$store.commit('setSleepCard', {});
        self.$store.commit('setMedicationCard', {});
        self.$store.commit('setCholesterolCard', {});
        self.$store.commit('setInsulinCard', {});
        self.$store.commit('setKetonesCard', {});
        self.$store.commit('setMoodCard', {});
        self.$store.commit('setCardOrder', {});
        self.$store.commit('setProvider', {});
        self.$store.commit('setMoodCard', {});


        axios.get(config.apiUrl + 'logout/').then(function (response) {
          if (_.has(axios.defaults.headers.common, 'Authorization')) {
            delete axios.defaults.headers.common['Authorization'];
          }

          AuthenticationManager.clearSession();
          self.$router.push({
            name: 'Login'
          })
        });

      },
      goToContact() {
        let self = this;
        self.$router.push({
          name: 'Contact'
        })
      },
      goBack(route) {
        let self = this;
        self.$router.go(-1);
      },
      /**
       * @param url
       * @returns {string|*}
       */
      replaceDashes(url) {
        let urlLength = url.length;
        url = url.split('-').join('.');
        return url;
      },
      upperFirstChar(string) {
        return string.charAt(0) + string.slice(1);
      },
      openNotificationPanel() {
        let self = this;
        self.isNotificationsPanelVisible = true;
      },
      away() {
        let self = this;
        self.isNotificationsPanelVisible = false;
      },
      hidePanelFn() {
        let self = this;
        self.isNotificationsPanelVisible = false;
      },
      checkOnboarding() {
        let self = this;

        if (self.$route.name === 'Subscription' || self.$route.name === 'Payment' || self.$route.name === 'AmendRegistration' || self.$route.name === 'Register') {
          return;
        }

        if (self.$store.state.status.payment.paid === false && self.$route.name !== 'AmendRegistration') {
          self.$router.push({
            name: 'Subscription',
          })
        } else {
          if (!self.isHcpUser) {
            if (
              ((self.$route.name === 'GettingStartedAboutYourself')
                ||
                (self.$route.name === 'GettingStartedYourHealth')
                ||
                (self.$route.name === 'GettingStartedLocation')
                ||
                (self.$route.name === 'GettingStartedGoals')
                ||
                (self.$route.name === 'GettingStartedPersonalise'))
            ) {
            } else {
              if (self.$store.state.status.onboarding.about === false) {
                self.$router.push({
                  name: 'GettingStartedAboutYourself'
                })
              } else {
                if (self.$store.state.status.onboarding.location === false) {
                  self.$router.push({
                    name: 'GettingStartedLocation'
                  })
                } else {
                  if (self.$store.state.status.onboarding.goals === false) {
                    self.$router.push({
                      name: 'GettingStartedGoals'
                    })
                  } else {
                    if (self.$store.state.status.onboarding.personalise === false) {
                      self.$router.push({
                        name: 'GettingStartedPersonalise'
                      })
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    computed: {
      showLogOut() {
        let routeName = this.$route.name
        return routeName === 'Subscription' || routeName === 'GettingStartedAboutYourself' || routeName === 'GettingStartedYourHealth' || routeName === 'GettingStartedLocation' || routeName === 'GettingStartedGoals' || routeName === 'GettingStartedPersonalise';
      },
      loggedIn() {
        let self = this;
        return _.has(self.$store.state.user, 'scope')
      },
      profileUrl: {
        get() {
          let self = this, url = self.$store.state.user.profile.profile_url;
          url = url.split('-').join('.');
          return url;
        },
        set() {
          let self = this, url = self.$store.state.user.profile.profile_url;
          url = url.split('-').join('.');
          return url;
        }
      },
      upperTwoInitials: {
        get() {
          let self = this;
          return self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name ?
            self.$store.state.user.scope.display_name.toString().charAt(0):
            self.$store.state.user.scope.firstname.charAt(0) + self.$store.state.user.scope.surname.charAt(0);
        }
      }
    }
  }
</script>
<style lang="less">
  footer.siteFooter.content {
    margin-top: 24px;
  }

  .white .mu-badge {
    color: white !important;
  }

  //LowCarb Stylesheet
  @import "../static/sprites/flags/flags.min.css";
  @import "~swal/dist/sweetalert2.css";
  @import "~animate/animate.css";
  @import "~toastr-component/build/toastr.css";
  @import "~material-components/dist/vue-material.css";
  @import "~muse-assets/muse-ui.css";
  @import "~mediumjs/medium.css";
  @import "~croppiejs/croppie.css";
  @import "./styles/getting-started.less";
  @import "./styles/tooltip.css";
  @import "./styles/theme.less";
  @import "./styles/general.css";
  @import "./styles/general.css";

  .mu-drawer {
    border-bottom-right-radius: 3rem;
    background-color: #fff;
    box-shadow: 1px 1px 20px -10px #5b617c;
  }
  .mu-drawer .mu-item-wrapper {
    margin: 2px 0;
  }

  .mu-drawer .recipe-menu .mu-list .mu-item-wrapper div, .mu-drawer .shop-menu .mu-list .mu-item-wrapper div {
    margin-left: 0!important;
  }
  .mu-drawer .recipe-menu .mu-list .mu-item-wrapper .mu-item .mu-item-left, .mu-drawer .shop-menu .mu-list .mu-item-wrapper .mu-item .mu-item-left, .mu-drawer .recipe-menu .mu-list .mu-item-wrapper .mu-item .mu-item-content,  .mu-drawer .shop-menu .mu-list .mu-item-wrapper .mu-item .mu-item-content{
    margin-left: 18px!important;
  }

  .logout-button {
    padding: 0 13px 4px;
    border-radius: 8px;
    border: solid 1px rgba(255, 255, 255, 0.18);
    transition: all .2s ease-in-out;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    span {
      font-size: 1rem;
    }
    i {
      font-size: 1rem;
      vertical-align: middle;
      margin-bottom: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?cfb19f6a